<template>
  <main class="a-service-main">
    <!-- S : 컨텐츠 영역 -->
    <div class="a-service-container">
      <div class="mypack_final" ref="mypackFinal">
        <pack-naming-section v-model="packName" :max-length="10" />

        <final-applied-item-info
          active-button="active"
          require-min-height
          desktop
          :final-products="finalProducts"
          :prices="prices"
          :days="days"
          :pockets="pockets"
        />
        <subscription-section
          v-model="subscription"
          @update-subscription-info="updateSubscriptionInfo"
          @update-min-height="updateMinHeight"
          ref="subscriptionSection"
        />
      </div>
      <main-button-group
        title-left="이전"
        :title-right="subscription.paymentType==='direct'?'상담 신청':'결제정보 입력 및 상담 신청'"
        :disabled-right="!canProceed"
        @click-left="$router.back()"
        @click-right="proceedNext"
      />
    </div>
    <!-- E : 컨텐츠 영역 -->
    <!-- S : 플로팅 버튼 -->

    <floating-button-group
      title="결제정보 입력 및 상담 신청"
      :disabled="!canProceed"
      @click="proceedNext"
    />
    <!-- E : 플로팅 버튼-->
    <modal-unavailable-products
      v-if="soldoutProducts"
      ref="refSoldout"
      :purchase-type="purchaseType"
      :cur-seq="1"
      :re-orderble="reOrderble"
      :re-cal-dose-info="reCalDoseInfo"
      :soldout-products="soldoutProducts"
      @remove-and-proceed="removeAndProceed"
      @cancel-pack="cancelPack"
    />
    <modal-alert ref="refAlert" />
    <modal-confirm ref="refConfirm" />
  </main>
</template>
<script>
import orderApi from "@/apis/order";
import { mapGetters } from "vuex";
import { log } from "@/utils/common";
import FinalAppliedItemInfo from "@/components/final-check/FinalAppliedItemInfo.vue";
import FloatingButtonGroup from "@/components/FloatingButtonGroup.vue";
import MainButtonGroup from "@/components/MainButtonGroup.vue";
import packApi from "@/apis/pack";
import productApi from "@/apis/product";
import productHelpers from "@/utils/helpers/product";
import { CONTEXT_TYPE, ERRORS } from "@/utils/constants";
import PackNamingSection from "./PackNamingSection.vue";
import SubscriptionSection from "./SubscriptionSection.vue";
import mixin from "../../common/mixin";
import compositionHelpers from "@/utils/helpers/composition";
import ModalUnavailableProducts from "@/components/modal-popups/ModalUnavailableProducts.vue";
import ModalAlert from "@/components/global/ModalAlert.vue";
import ModalConfirm from "@/components/global/ModalConfirm.vue";

export default {
  name: "CompositionStep3",
  components: {
    PackNamingSection,
    FinalAppliedItemInfo,
    SubscriptionSection,
    MainButtonGroup,
    FloatingButtonGroup,
    ModalUnavailableProducts,
    ModalAlert,
    ModalConfirm,
  },
  mixins: [mixin],
  props: {
    // finalProducts: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    return {
      subscription: {
        purchaseType: "single",
        requestType: "VCALL",
        abcCd: "bundang",
        billingDate: "",
        billingStatus: "",
      },
      packName: "",
      prices: null,

      isSoldout: null,
      soldoutSkus: null,
      soldoutName: null,
      isEndOfSale: null,
      endOfSaleSkus: null,
      endOfSaleName: null,
      reOrderble: null,
      reCalDoseInfo: null,
      soldoutProducts: null,
    };
  },
  mounted() {
    const subscription = this.context.bundle.step3.subscription;
    if (!!subscription) {
      this.subscription = subscription;
    }
    this.updateMinHeight();
  },
  computed: {
    ...mapGetters({
      context: "context/context",
      products: "product/products",
    }),
    finalProducts() {
      return productHelpers.getProductsFromSkus(
        this.products,
        this.context.bundle.step2.finalSkus
      );
    },
    canProceed() {
      if (
        !this.packName ||
        !this.subscription.purchaseType ||
        !this.subscription.requestType
      ) {
        return false;
      }

      if (this.subscription.requestType == "VCALL") {
        if (this.subscription.abcCd != "bundang") {
          return false;
        }
      } else if (this.subscription.requestType == "ABC") {
        if (!this.subscription.abcCd) {
          return false;
        }
      }

      if (this.subscription.purchaseType == "recurring") {
        if (!this.subscription.billingDate) {
          return false;
        }
      }
      return true;
    },
    days() {
      return this.context.bundle.step2.finalSkus[0].days;
    },
    pockets() {
      return this.context.bundle.step2.finalSkus[0].pockets;
    },
    purchaseType() {
      return this.subscription.purchaseType;
    },
    abcCd() {
      return this.subscription.abcCd;
    },
    reqNo() {
      return this.context.bundle.step3.reqNo || "";
    },
    productsDetails() {
      return this.context.bundle.step2.finalSkus.map((n) => {
        const product = this.products.find((p) => p.item_sku === n.item_sku);
        return {
          item_sku: n.item_sku,
          item_name: product ? product.item_name : null,
          pockets: n.pockets,
          seq: n.seq,
        };
      });
    },
  },
  created() {
    if (this.finalProducts.length === 0) {
      this.$router.back();
    }

    this.packName = this.context.bundle.step3.packName
      ? this.context.bundle.step3.packName
      : "";
  },
  async beforeMount() {
    await this.calculatedPrices();
  },
  methods: {
    async calculatedPrices() {
      const doseInfo = this.finalProducts.map((n) => ({
        item_sku: n.item_sku,
        dose_cnt: n.seq.split(",").reduce((acc, n2) => acc + parseInt(n2, 10), 0),
      }));
      const params = {
        dose_info: doseInfo,
        take_days: this.days,
      };

      try {
        const r = await productApi.getCalculatedPrices(params);
        this.prices = r;
      } catch (e) {
        log("CompositionStep3::beforeMount.catch", e);
      }
    },
    setContextWithStep3() {
      const ctx = JSON.parse(JSON.stringify(this.context));
      compositionHelpers.updateStep3(
        ctx,
        this.packName,
        this.reqNo,
        this.subscription,
        this.prices,
      );
      compositionHelpers.updateContext(this.$store, ctx);
    },
    async proceedNext() {
      const isUnavailableProducts = await this.isUnavailableProducts();
      if (isUnavailableProducts) {
        await this.$refs.refSoldout.open();
        return;
      }

      // ASB-13103: [마이팩] 즉시결제 할부 기능 업데이트
      if (this.subscription.purchaseType == "single" && this.subscription.paymentType == "direct") {
        this.directPayment()
      } else {
        this.proceedNextInternal();
      }
      // ASB-13103: [마이팩] 즉시결제 할부 기능 업데이트
    },
    proceedNextInternal() {
      this.setContextWithStep3();
      this.$router.push({
        name: "composition-payment",
      });
    },
    updateSubscriptionInfo(subscription) {
      const {
        purchaseType,
        requestType,
        abcCd,
        billingDate,
        billingStatus,
        paymentType
      } = subscription;

      this.subscription = {
        ...this.subscription,
        purchaseType,
        requestType,
        abcCd,
        billingDate,
        billingStatus,
        paymentType
      };
    },
    updateMinHeight() {
      this.$nextTick(() => {
        const mypackFinal = this.$refs.mypackFinal;
        const subscriptionSection = this.$refs.subscriptionSection;
        const choiceItem =
          subscriptionSection && subscriptionSection.$refs.subscription;

        if (choiceItem && mypackFinal) {
          const contentHeight = choiceItem.offsetHeight + 300;
          mypackFinal.style.minHeight = contentHeight + "px";
        }
      });
    },
    async isUnavailableProducts() {
      const abcCd = orderApi.getAbcCd({
        purchase_type: this.purchaseType,
        cur_seq: 1,
        abc_cd: this.abcCd,
      });
      const r = await orderApi.checkSoldOut("C", this.productsDetails, abcCd);

      if (r.error) {
        console.error(r.error);
        return;
      }
      log("######### checkSoldOut results #########", r);

      const {
        isSoldout,
        soldoutSkus,
        soldoutName,
        isEndOfSale,
        endOfSaleSkus,
        endOfSaleName,
        reOrderble,
        reCalDoseInfo,
      } = r;

      if (isSoldout || isEndOfSale) {
        this.isSoldout = isSoldout;
        this.soldoutSkus = soldoutSkus;
        this.soldoutName = soldoutName;
        this.isEndOfSale = isEndOfSale;
        this.endOfSaleSkus = endOfSaleSkus;
        this.endOfSaleName = endOfSaleName;
        this.reOrderble = reOrderble;
        this.reCalDoseInfo = reCalDoseInfo;
        this.soldoutProducts = productHelpers.getSoldoutProducts(
          this.products,
          this.productsDetails,
          this.soldoutSkus,
          this.endOfSaleSkus
        );
        return true;
      }
      return false;
    },
    async removeAndProceed() {
      try {
        await this.$refs.refConfirm.openWithMessage(
          "단종 또는 일시품절 등의 제품을 제외하고 마이팩을 주문하시겠습니까?"
        );

        let finalSkus = this.context.bundle.step2.finalSkus;
        finalSkus = finalSkus.filter(
          (n) =>
            ![...this.soldoutSkus, ...this.endOfSaleSkus].includes(n.item_sku)
        );

        const ctx = JSON.parse(JSON.stringify(this.context));
        compositionHelpers.updateStep2(ctx, finalSkus);
        compositionHelpers.updateContext(this.$store, ctx);

        await this.calculatedPrices();
        await this.$refs.refSoldout.onDispose();
        this.proceedNextInternal();
      } catch (e) {
        console.log(e);
      }
    },
    async cancelPack() {
      if (this.isEndOfSale || this.isSoldout) {
        await this.$refs.refConfirm
          .openWithMessage(
            "단종 또는 일시품절 등의 제품으로 인해 마이팩 구매를 취소하시겠습니까?"
          )
          .then(() => {
            this.$refs.refSoldout.onDispose();
            this.$router.replace("/");
          })
          .catch(() => {});
      }
    },
    async resetStore() {
      await this.$store.dispatch("context/unset");
      await this.$store.dispatch("agreement/init");
      await this.$store.dispatch("payment/reset");
    },
    async directPayment() { // ASB-13103: [마이팩] 즉시결제 할부 기능 업데이트
      this.setContextWithStep3()
      // 일반 재조합인지, 신청번호가 있는 재조합인지 여부에 따라 다른 api호출
      const productDetail = [];
      this.finalProducts.forEach((n) =>
        productDetail.push({
          item_sku: n.item_sku,
          dose: n.pockets,
          dose_list: n.seq,
        })
      );

      const dataForGettingAppliedDetail = {
        packName: this.packName,
        takeDays: this.days,
        orderType: "",
        abcCd: this.context.bundle.step3.subscription.abcCd,
        totalPrice: this.context.bundle.step3.prices.price,
        totalPv: this.context.bundle.step3.prices.pv,
        totalBv: this.context.bundle.step3.prices.bv,
        dose: this.pockets,
        detail: productDetail,
        reqNo: this.context.bundle.step3.reqNo,
        cfm_kind: this.context.bundle.step3.subscription.requestType,
        purchaseType: this.context.bundle.step3.subscription.purchaseType,
        receivePhone: "",
        deliveryAddress: "",
        deliveryMessage: "",
        billingDate: this.context.bundle.step3.subscription.billingDate,
        billingStatus: this.context.bundle.step3.subscription.billingStatus,
        paymentInfo: {
          paymentMode: "",
          paymentCode: "",
          customerId: "",
          issuerCode: "",
          issuerName: "",
          installmentPlan: "",
          receiptType: "",
          receiptIssuanceType: "",
          receiptNumberType: "",
          receiptIssuanceNumber: "",
        },
        paymentType: this.context.bundle.step3.subscription.paymentType,
      };

      log("dataForGettingAppliedDetail", dataForGettingAppliedDetail);
      log("this.context.name", this.context.name);

      let r = {};
      r = await packApi.postCompleteAppliance({
        ...dataForGettingAppliedDetail,
        reorder: false,
        consultation: "",
      });

      log( "r", r);
      if (r.error) {
        console.error(r.error);
        return;
      }

      await this.$refs.refAlert.openWithMessage(
        "상담 신청 되었습니다."
      );
      await this.resetStore();
      await this.$router.replace("/mypacks");
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/composition/main/step3/CompositionStep3.vue